import { render, staticRenderFns } from "./CoTwoProductionLogistic.vue?vue&type=template&id=dfe4a594&scoped=true&"
import script from "./CoTwoProductionLogistic.vue?vue&type=script&lang=js&"
export * from "./CoTwoProductionLogistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe4a594",
  null
  
)

export default component.exports